import { useMemo } from 'react'
import { useCart } from './CartContext'

/**
 * Hook to find cart selection for quick add items (items without custom modifiers)
 * Returns the selection and total quantity for the base item
 */
export const useCartItemForQuickAdd = (itemGuid?: string | null) => {
  const { cart } = useCart()

  return useMemo(() => {
    if (!cart?.order?.selections || !itemGuid) {
      return {
        selection: null,
        quantity: 0,
        selectionGuid: null,
        totalQuantity: 0
      }
    }

    const matchingSelections = cart.order.selections.filter(
      (selection) => selection?.itemGuid === itemGuid
    )

    if (!matchingSelections.length) {
      return {
        selection: null,
        quantity: 0,
        selectionGuid: null,
        totalQuantity: 0
      }
    }

    const matchingSelection = matchingSelections[0]

    const totalQuantity =
      matchingSelections.length > 1
        ? matchingSelections.reduce((total, selection) => {
            if (
              selection?.usesFractionalQuantity &&
              selection?.fractionalQuantity
            ) {
              return total + selection.fractionalQuantity.quantity
            }
            return total + (selection?.quantity || 0)
          }, 0)
        : matchingSelection?.usesFractionalQuantity &&
          matchingSelection?.fractionalQuantity
        ? matchingSelection.fractionalQuantity.quantity
        : matchingSelection?.quantity || 0

    return {
      selection: matchingSelection,
      totalQuantity
    }
  }, [cart?.order?.selections, itemGuid])
}
